import React, { useState, useRef, useContext } from "react";
import AudioPlayer from 'react-audio-player';
import '../../css/recording.css';
import Icon from "../../assets/icons/icon";
import { fileServer } from "../../config/commUrls";
import { fetchWithDefaults } from "../../config/fetchDefault";
import { useSelector } from "react-redux";
import { AgentContext } from "../../context/AgentContext";

function AudioElement({audio, type, handleDeleteRecording, section, setActiveVoicemail}) {
    const agentId=useSelector((state) => state.agent.userData).agentId;
  const [voicemailMsg,setvoicemailMsg] = useState('');
    const [isPlaying, setIsPlaying] = useState(false);
    const audioPlayerRef = useRef(null);
    const onAudioEnded = () => setIsPlaying(false);

    const [open, setOpen] = useState(false);

    const openUp=()=>{
        setOpen((prevOpen) => !prevOpen);
    }

    const togglePlay = () => {
        setIsPlaying(!isPlaying);
    };

    const makeSetToVoicemail = async (voicemail_Id, name) => {
        if (voicemail_Id !== '') {
            const formData = new FormData();
            formData.append('voicemail_url', voicemail_Id);
            formData.append('agent', agentId);

            try {
                const response = await fetchWithDefaults(`/voicemail/setAsVoicemail`, {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    const jsonData = await response.json();
                    if (jsonData.status) {
                        setvoicemailMsg(`${name} successfully set to voicemail`);
                        setActiveVoicemail(voicemail_Id);
                        // Clear success message after 3 seconds
                        setTimeout(() => {
                            setvoicemailMsg('');
                        }, 3000);
                    }
                } else {
                    console.error('Error in set to voicemail');
                }
            } catch (error) {
                console.error('Error:', error.message);
            }
        }

    };
    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector(state => state.colorData)
    return (
        <div className="quilityNestedBlockWrapper">
            <span className="quilityNestedBlockHeader" onClick={(event) => { event.stopPropagation();openUp();}}>

                <div className="quilityCloseWindow oulineQuilityDestructiveButton" style={{top:'5px'}} onClick={()=>handleDeleteRecording(audio.id, type)}><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span></div>
            </span>
            <div className={`quilityNestedBlockContent`}>
                    <div className='quilityDataLine'>
                        <div className="recordingHolder">
                            <AudioPlayer
                                ref={audioPlayerRef}
                                src={`${fileServer}/`+section+"/"+audio.id+"."+audio.ext}
                                autoPlay={false}
                                controls
                                onEnded={onAudioEnded}
                                className="audioPlayerStyles"
                            />
                        </div>
                    </div>
                    <div className='quilityDataLine'>
                        <div className="quilityDataLineTitle" style={{width: '60px'}}>Name: </div>
                        <span className="rename">{audio.name}</span>
                        {type==='voicemail' && audio.isSelectedAsVoiceUrl === 1 && (
                            <span className="voicemailActiveBadge">Active</span>
                        )}
                    </div>
                    {voicemailMsg && (
                        <div className='quilityDataLine voicemailSuccessMessage'>
                            {voicemailMsg}
                        </div>
                    )}
                    {type=='voicemail' ? (
                        <div className='quilityDataLine'>
                            <div className={`accentButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>makeSetToVoicemail(audio.id, audio.name)}>Set As Voicemail</div>
                        </div>
                    ):(
                        null
                    )}

            </div>
        </div>
    );
}

export default AudioElement;

